var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('CenteredHeader',{attrs:{"text":"WORK IN PROGRESS"}}),_c('div',{staticClass:"header-text"},[_vm._v("ALGORITHMS")]),_c('div',{staticClass:"article-header"},[_vm._v("Array slices with dynamic programming")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }